<nav class="navbar nav sticky-top main-nav justify-content-start">
  <button
    class="navbar-toggler p-0 mr-24"
    type="button"
    aria-label="Toggle navigation"
    (click)="openSidebar()"
  >
    <i class="fa fa-bars text-light navbar-toggler-icon"></i>
  </button>

  <li class="nav-item mr-4">
    <a
      routerLinkActive="active"
      routerLink="/live-orders"
      class="nav-link pointer"
    >
      <img class="active" src="/assets/icons/live-orders-active.svg" alt="" />
      <img class="inactive" src="/assets/icons/live-orders.svg" alt="" />
      <span class="nav-text">Live orders</span>
    </a>
  </li>
  <li class="nav-item">
    <a
      routerLinkActive="active"
      routerLink="/completed-orders"
      class="nav-link pointer"
    >
      <img
        class="active"
        src="/assets/icons/completed-orders-active.svg"
        alt=""
      />
      <img class="inactive" src="/assets/icons/completed-orders.svg" alt="" />
      <span class="nav-text">Completed orders</span>
    </a>
  </li>

  <div
    class="d-md-flex flex-md-row gap-12 flex-column align-items-md-center ml-auto align-items-start d-none"
  >
    <p
      *ngIf="credentials()?.restaurant?.name"
      class="text-light lh-24 mb-0 fw-600"
    >
      {{ credentials()?.restaurant?.name }}
    </p>

    <mat-slide-toggle
      [checked]="isOnline === true"
      (change)="changeOnlineStatus($event.checked)"
      class="f-14 text-light"
    >
      {{ isOnline ? 'Online' : 'Offline' }}
    </mat-slide-toggle>
  </div>
</nav>
